/**
 * Frontend-Service: Blog-Benachrichtigungs-Einstellungen
 *
 * REST-Wrapper für GET/PATCH /auth/user/blog-notifications.
 * Wird vom useBlogNotificationPreferences-Hook konsumiert.
 */

import apiClient from '../api/apiClient';

export interface BlogNotificationPreferences {
  enabled: boolean;
  optedOutAt: string | null;
}

interface SuccessEnvelope<T> {
  success: true;
  data: T;
}

export async function fetchBlogNotificationPreferences(): Promise<BlogNotificationPreferences> {
  const res = await apiClient.get<SuccessEnvelope<BlogNotificationPreferences>>(
    '/auth/user/blog-notifications'
  );
  return res.data.data;
}

export async function updateBlogNotificationPreferences(
  enabled: boolean
): Promise<BlogNotificationPreferences> {
  const res = await apiClient.patch<SuccessEnvelope<BlogNotificationPreferences>>(
    '/auth/user/blog-notifications',
    { enabled }
  );
  return res.data.data;
}
